import store from "../../../store";
import dots_export from './dots_export.vue';

window.dots_export =  new Vue({
    store,
    el: 'div#dots_export',

    name : "dots_export",
    data () {
        return {

        }
    },
    created () {

    },
    components : {
        dots_export,
    }
});
